
import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as tpaDailyReportAction from "../../../store/tpadaily-report/action";
import { post, postUpload } from "../../../helpers/api_helper";
import "flatpickr/dist/themes/material_blue.css";
import React, { useState, useEffect, useMemo } from "react";

import {
    SAVE_ONSHORE_RP_TPA_DAILY_REPORT,
    SAVE_LIST_ONSHORE_RP_TPA_DAILY_REPORT,
    DELETE_ONSHORE_RP_TPA_DAILY_REPORT,
    GET_ONSHORE_RP_TPA_DAILY_REPORT,
} from "../../../helpers/url_api_constant";

import {
    Col,
    Container,
    Input,
    Row,
    TabContent,
    TabPane,
    Table,
    InputGroup,
} from "reactstrap";

import PropTypes from "prop-types";

import "../../../assets/scss/datatables.scss";

import OverButton from "../../../components/Custom/Overbutton";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import Flatpickr from "react-flatpickr";
import debounce from "lodash.debounce";

function TableFour(props) {
    let history = useHistory();
    let { pid } = useParams();

    const dispatch = useDispatch();
    const permission = getPermission();
    const searchObj = { TPADAILY_PID: pid, };

    const model = {
        TPADAILY_PID: props.tpaDailyReportPid,
        TPAONSHORE_DATA: 0,
    };

    const [onshoreModel, setOnshoreModel] = useState(model);

    //render Index//
    const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
    //render Index//

    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = 'white';

        return style;
    };

    //onInit//
    useEffect(function () {
        fetchData();
        // resetSearch();
        // resetModel();
        // setModelDeviceList(listData);
    }, [props.tpaDailyReportPid]);
    //onInit//

    const setDispatchAction = useMemo(
        () =>
            debounce((value) => {
                // console.log(value);
                dispatch(
                    tpaDailyReportAction.setTableFourOnshoreToState({
                        ...value,
                        TPAONSHORE_DATA: value.TPAONSHORE_DATA,
                    })
                );
            }, 300),
        []
    );

    useEffect(() => {
        setDispatchAction(onshoreModel);
    }, [onshoreModel]);

    const fetchData = async () => {
        // dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_ONSHORE_RP_TPA_DAILY_REPORT, { TPADAILY_PID: props.tpaDailyReportPid });
            // console.log(res);
            let data = res.data.rpTPAOnshoreList[0]
            setOnshoreModel({ ...data, TPAONSHORE_DATA: data.TPAONSHORE_DATA.toFixed(2) });
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        // dispatch(loadingAction.hideLoading());
    };

    return (
        // <div>
        <Row>
            <Col sm="1"></Col>
            <Col sm="10">
                <div className="table-responsive">
                    {/* hover-table-highlight */}

                    <Table className="table table-bordered mb-0">
                        <thead>
                            <tr>
                                <th colSpan={2} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "center", width: "100%" }}>ข้อมูลสรุปการบริหารจัดการก๊าซบนบก  (หน่วย: %)</th>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: "#556ee678", color: "#FFFFFF", textAlign: "center", width: "25%" }}>รายการ</th>
                                <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "25%" }}>Total Onshore</th>
                            </tr>
                        </thead>
                        <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                            <tr>
                                {/* <td><label style={{ fontSize: "14px" }}>ความไม่สมดุลของระบบส่งก๊าซธรรมชาติบนบก (%)</label></td>   //ของไฟล์แรก */}
                                <td><label style={{ fontSize: "14px" }}>การบริหารสมดุลของระบบส่งก๊าซรวม (%)</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                style={{ textAlign: "right", }}
                                                type="number"
                                                className="form-control basicborder"
                                                // disabled
                                                readOnly={props.readOnly}
                                                onChange={(e) => setOnshoreModel(
                                                    {
                                                        ...onshoreModel,
                                                        TPAONSHORE_DATA: e.target.value
                                                    })
                                                }
                                                value={onshoreModel.TPAONSHORE_DATA}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </Col>
            <Col sm="1"></Col>
        </Row>
        // </div>
    );
}

TableFour.propTypes = {
    t: PropTypes.any,
    tpaDailyReportPid: PropTypes.any,
    readOnly : PropTypes.any,
};

export default TableFour;


